import dAgeWithTooltip from "discourse/ui-kit/helpers/d-age-with-tooltip";

const DRelativeDate = <template>{{dAgeWithTooltip @date}}</template>;

export default DRelativeDate;
